var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stream-editor-parameter-panel__prop"},[_c('div',{staticClass:"stream-editor-parameter-panel__prop-title"},[_vm._v("Youtube Link / ID")]),_c('ParameterInput',{attrs:{"prop":{..._vm.activeComponent.props.youtubeId, key: 'youtubeId'},"size":_vm.size,"active-size":_vm.size,"value-type":_vm.valueType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }